import { Flex } from 'reflexbox';
import styled from 'styled-components';

export const InboxManagerTableRow = styled(Flex)<{ header?: boolean; clickable?: boolean }>`
	flex-direction: row;
	align-items: stretch;
	height: 40px;

	${(props) =>
		props.clickable &&
		`
	cursor: pointer;

	&:hover {
		background: ${props.theme.colors.lightBlueLight};
	}
`}
`;

export const InboxManagerTableCell = styled.div<{
	small?: boolean;
	bold?: boolean;
	sortable?: boolean;
	width?: number;
}>`
	padding: 10px;
	color: ${(props) => props.theme.colors.slateBlue};
	width: ${(props) => props.width ?? (props.small ? 50 : 150)}px;
	flex-shrink: 0;
	flex-grow: 0;
	white-space: nowrap;
	display: flex;
	align-items: center;
	flex-flow: row;
	${(props) => props.sortable && `cursor: pointer; user-select: none;`}
	${(props) => props.bold && `font-weight: bold;`}
`;
